define('builderShowcaseState',[
], () => {
  'use strict';

  const defaultParameters = {
    Adult: false,
    AgeRestricted: false,
    Bathrooms: 0,
    Bedrooms: 0,
    BrandId: 0,
    Brands: [],
    CommName: '',
    CommunityStatus: '',
    ComingSoon: false,
    Custom: false,
    CustomResults: false,
    ExcludeBrandsFromResults: true,
    ExcludeRegularComms: false,
    Gated: false,
    GolfCourse: false,
    Green: false,
    Qmi: false,
    HomeStatus: '',
    HotDeals: false,
    IncludeMpc: true,
    LuxuryHomes: false,
    Mfr: false,
    MultiFamily: false,
    NatureAreas: false,
    NoBoyl: true,
    NumStory: 0,
    OriginLat: 0,
    OriginLng: 0,
    PartnerId: 0,
    Parks: false,
    Pool: false,
    PriceHigh: 0,
    PriceLow: 0,
    SchoolDistrictIds: '',
    SingleFamily: false,
    Sports: false,
    SqFtHigh: 0,
    SqFtLow: 0,
    SrpType: 'CommunityResults',
    Views: false,
    Waterfront: false,
    Garages: 0,
    LivingAreas: 0,
    Stories: 0,
    MasterBedLocation: 0,
    CommId: 0,
    HasRVGarage: false,
    MarketId: 0,
    State: '',
    MarketName: '',
    WebApiSearchType: 'Map',
  };

  const pageData = JSON.parse(document.querySelector('[data-component="builder-showcase-data"]').innerHTML);
  const partnerElement = document.querySelector('#nhs_partnerID');

  const builderShowcaseData = {
    searchParameters: defaultParameters,
    data: pageData,
    locations: pageData.LocationsSection,
    parterId: partnerElement.value,
  };

  if (pageData.LocationsSection) {
    builderShowcaseData.searchParameters.OriginLat = builderShowcaseData.locations.Latitude;
    builderShowcaseData.searchParameters.OriginLng = builderShowcaseData.locations.Longitude;
    builderShowcaseData.searchParameters.Zoom = builderShowcaseData.locations.ZoomLevelToUse;

    if (builderShowcaseData.locations.PreSelectedMarket) {
      builderShowcaseData.searchParameters.MarketId = builderShowcaseData.locations.PreSelectedMarket.Id;
      builderShowcaseData.searchParameters.MarketName = builderShowcaseData.locations.PreSelectedMarket.Name;
      builderShowcaseData.searchParameters.State = builderShowcaseData.locations.PreSelectedMarket.StateAbbr;
    }
  }

  /**
  * @public
  * getState: returns a copy of the BSP's current state.
  *
  */
  function getState() {
    return Object.assign({}, builderShowcaseData);
  }

  /**
  * @public
  * getParameters: returns a copy of the BSP's current search parameters.
  *
  */
  function getParameters() {
    return Object.assign({}, builderShowcaseData.searchParameters);
  }

  /**
  * @public
  * setSearchParamsAttributes: modifies a set of attributes in search params.
  * @param {object} object with a set of attributes to change on search params.
  */
  function setSearchParamsAttributes(object) {
    if (!object) {
      return;
    }

    const objectEntries = Object.entries(object);

    for (let i = 0; i < objectEntries.length; i += 1) {
      builderShowcaseData.searchParameters[objectEntries[i][0]] = objectEntries[i][1];
    }
  }

  /**
  * @public
  * setSearchParamsAttributes: modifies a set of attributes in the data.
  * @param {object} object with a set of attributes to change the data.
  */
  function setData(object) {
    if (!object) {
      return;
    }

    const objectEntries = Object.entries(object);

    for (let i = 0; i < objectEntries.length; i += 1) {
      builderShowcaseData.data[objectEntries[i][0]] = objectEntries[i][1];
    }
  }

  return {
    getState,
    getParameters,
    setSearchParamsAttributes,
    setData,
  };
});

